import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { auth } from "./api.ts";

/**
 * Production auth (D-4/D-16): Google + magic link via Supabase Auth. The client
 * exists only when the build carries the project config (.env.production);
 * dev/CI/E2E builds leave it null and use the API's dev login instead.
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const supabase: SupabaseClient | null = url && key ? createClient(url, key) : null;

// Keep the API client's bearer token in lockstep with the Supabase session
// (sign-in, silent refresh, sign-out) — api.ts stays auth-provider-agnostic.
supabase?.auth.onAuthStateChange((event, session) => {
  if (session?.access_token) auth.setToken(session.access_token);
  else if (event === "SIGNED_OUT") auth.clear();
});
